const stats = [
  {
    value: '50,000+',
    label: 'Spreadsheet Links',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20photograph%20of%20organized%20product%20links%20and%20bookmarks%20on%20a%20clean%20desk%2C%20neatly%20arranged%20reference%20cards%2C%20warm%20ambient%20lighting%2C%20minimal%20workspace%20aesthetic%2C%20soft%20shadows&width=200&height=200&seq=trust-img-01-vb&orientation=squarish',
    imageAlt: 'VigorBuy Spreadsheet links collection',
  },
  {
    value: 'Updated Daily',
    label: 'Fresh Content',
    imageUrl: 'https://readdy.ai/api/search-image?query=Calendar%20and%20clock%20on%20a%20modern%20desk%20with%20fresh%20flowers%2C%20concept%20of%20daily%20updates%20and%20freshness%2C%20bright%20natural%20light%2C%20clean%20minimal%20composition%2C%20editorial%20photography&width=200&height=200&seq=trust-img-02-vb&orientation=squarish',
    imageAlt: 'VigorBuy Spreadsheet updated daily',
  },
  {
    value: 'Trusted',
    label: 'Verified Sellers',
    imageUrl: 'https://readdy.ai/api/search-image?query=Verified%20badge%20and%20certificate%20on%20a%20clean%20surface%20with%20a%20small%20plant%2C%20concept%20of%20trust%20and%20verification%2C%20soft%20natural%20lighting%2C%20minimal%20studio%20photography%2C%20warm%20cream%20background&width=200&height=200&seq=trust-img-03-vb&orientation=squarish',
    imageAlt: 'VigorBuy Spreadsheet trusted sellers badge',
  },
  {
    value: 'QC Verified',
    label: 'Quality Assured',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20product%20quality%20checklist%20on%20a%20clean%20desk%2C%20concept%20of%20quality%20control%20and%20inspection%2C%20bright%20natural%20daylight%2C%20professional%20workspace%20aesthetic%2C%20warm%20neutral%20tones&width=200&height=200&seq=trust-img-04-vb&orientation=squarish',
    imageAlt: 'VigorBuy Spreadsheet QC verified quality assurance',
  },
];

export default function TrustBar() {
  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center group">
              <div className="w-20 h-20 mx-auto mb-4 rounded-2xl overflow-hidden border-2 border-background-200/70 group-hover:border-accent-300 transition-colors">
                <img
                  src={stat.imageUrl}
                  alt={stat.imageAlt}
                  title={stat.label}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1 whitespace-nowrap">{stat.value}</div>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}